import { render, staticRenderFns } from "./dialog-invoice.vue?vue&type=template&id=52557be6&"
import script from "./dialog-invoice.vue?vue&type=script&lang=js&"
export * from "./dialog-invoice.vue?vue&type=script&lang=js&"
import style0 from "./dialog-invoice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports